import {
  Product2Schema_,
  Product2VariantSchema_,
} from "@redotech/redo-model/product2/product2-types";
import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const PaginationInputSchema = z
  .object({
    pageSize: z.number().min(1).max(1000).default(50),
    cursor: OpensearchPaginationCursorSchema.optional(),
  })
  .optional();

const SortInputSchema = z
  .object({ field: z.string(), order: createEnum(["asc", "desc"]) })
  .optional();

export const SalesDataSchema = z.object({
  totalSold: z.number().min(0).default(0),
  totalRevenue: z.number().min(0).default(0), // in cents
  orderCount: z.number().min(0).default(0),
});

export const VariantSalesDetailsSchema = Product2VariantSchema_.extend({
  available: z.number().min(0).default(0),
  salesData: SalesDataSchema.optional(),
});

const ConsignedProductDetailsSchema_ = Product2Schema_.extend({
  variants: z.array(VariantSalesDetailsSchema),
});
export const ConsignedProductDetailsSchema: z.ZodType<ConsignedProductDetails> =
  ConsignedProductDetailsSchema_;
export interface ConsignedProductDetails
  extends z.infer<typeof ConsignedProductDetailsSchema_> {}

export const listConsignedProducts = unaryRpc({
  name: "listConsignedProducts" as const,
  input: z.object({
    search: z.string().optional(),
    pagination: PaginationInputSchema,
    sort: SortInputSchema,
  }),
  output: z.object({
    products: z.array(ConsignedProductDetailsSchema),
    totalCount: z.number(),
    nextCursor: OpensearchPaginationCursorSchema.optional(),
    prevCursor: OpensearchPaginationCursorSchema.optional(),
  }),
});
